import React from "react";
import PropTypes from "prop-types";

import Select from "../select";
import styles from "./paginationLength.scss";

export const DEFAULT_PAGE_LIMIT = 10;
export const PAGE_LIMIT_OPTIONS = [
  {
    key: 10,
    displayName: 10,
  },
  {
    key: 20,
    displayName: 20,
  },
  {
    key: 30,
    displayName: 30,
  },
  {
    key: 40,
    displayName: 40,
  },
  {
    key: 50,
    displayName: 50,
  },
];

const VARIANTS = { ROUND: "round" }
function PaginationLength({ value, onChange, totalCount, label, variant }) {

  const getValue = () => {
    if (typeof value !== 'object') {
      switch (variant) {
        case VARIANTS.ROUND:
          const returnValue = PAGE_LIMIT_OPTIONS.find(({ key }) => key === value)
          return { ...returnValue, displayName: `Show ${returnValue.key} rows` }
        default:
          return PAGE_LIMIT_OPTIONS.find(({ key }) => key === value)
      }
    } else {
      switch (variant) {
        case VARIANTS.ROUND:
          return { ...value, displayName: `Show ${value.key} rows` }
        default:
          return value;
      }
    }
  }

  const renderLabel = () => {
    switch (variant) {
      case VARIANTS.ROUND: {
        return <></>
      }
      default: {
        return <span className={styles.rowTxt}>{label}</span>
      }
    }
  }

  return totalCount > DEFAULT_PAGE_LIMIT ? (
    <div className={styles.rowWrap}>
      {renderLabel()}
      <Select
        value={getValue()}
        onChange={onChange}
        options={PAGE_LIMIT_OPTIONS}
        selectWrapperClass={styles.paginationLengthWrapper}
        placeholder="Sort By"
        label=""
        required
        name="filterType"
        variant={variant}
      />
    </div>
  ) : null;
}
PaginationLength.defaultProps = {
  value: PAGE_LIMIT_OPTIONS[0],
  label: "row",
  variant: "",
};

PaginationLength.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  totalCount: PropTypes.number,
  label: PropTypes.string,
  variant: PropTypes.oneOf(['', 'round']),
};

export default PaginationLength;
